import * as THREE from 'three';

export const setupLights = (scene) => {
  // Ambient light for overall illumination
  const ambientLight = new THREE.AmbientLight(0x404040, 1);
  scene.add(ambientLight);
  
  // Main directional light
  const mainLight = new THREE.DirectionalLight(0xffffff, 1);
  mainLight.position.set(10, 10, 10);
  scene.add(mainLight);
  
  // Fill light with cool tone
  const fillLight = new THREE.DirectionalLight(0x00eeff, 0.5);
  fillLight.position.set(-10, 5, -10);
  scene.add(fillLight);
  
  // Accent point light with warm tone
  const accentLight = new THREE.PointLight(0xff00aa, 1, 20);
  accentLight.position.set(0, 5, 0);
  scene.add(accentLight);

  return {
    ambientLight,
    mainLight,
    fillLight,
    accentLight
  };
};